import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import { cdn_url } from '@shared/cdn';
import { T_ } from '@shared/translation';
import LocalTracking from '@shared/tracking-local';
import tpl from '../templates/login.html';
import logoTpl from '../templates/fl-logo.html';
import appStoreTpl from '../templates/apple-app-store.html';
import playStoreTpl from '../templates/google-play-store.html';

export default Backbone.View.extend({
  template: _.template(tpl),

  initialize(options) {
    this.vent = options.vent;
    this.$el = $(this.el);
    this.options = {
      title: options.title || T_('Login to Freelancer.com'),
      signupTitle: options.signupTitle,
      welcomeMsg: options.welcomeMsg || '',
      keep: options.keep || false,
      hideFacebook: !!options.hideFacebook,
      hideLookingFor: !!options.hideLookingFor,
      isLoginSignup: this.options.isLoginSignup,
      isFreemarket: this.options.isFreemarket,
      // LJ-375
      switchToAlternateSignup: this.options.hasOwnProperty(
        'switchToAlternateSignup',
      )
        ? this.options.switchToAlternateSignup
        : false,
    };
    this.model.bind('username:valid', this.onValidUsername, this);
    this.model.bind('username:invalid', this.onInvalidUsername, this);
    this.model.bind('password:valid', this.onValidPassword, this);
    this.model.bind('password:invalid', this.onInvalidPassword, this);
    this.model.bind('success', this.onSuccess, this);
    this.model.bind('error', this.onError, this);
    this.model.bind('warning', this.onWarning, this);
    this.model.bind('redirection', this.onRedirection, this);
    this.model.bind('suspended', this.onSuspended, this);
  },

  events: {
    'submit #login_form': 'login',
    'click #playStore': 'trackPlayStoreClick',
    'click #appStore': 'trackAppStoreClick',
    'click #forgot-password-btn': 'showRecoverPassword',
    'click #fb-login-btn': 'clickFBLogin',
    'click .switch-to-login': 'switchToSignup',
    'click .close': 'close',
    'focus input': 'clearError',
  },

  clearError() {
    const inputs = this.$el.find('input');
    inputs.closest('.form-step').removeClass('is-invalid');
    this.$el
      .find('.form-error')
      .text('')
      .hide();
  },

  onInvalidUsername(reason) {
    this.$el.find('#login_btn').removeClass('processing');
    const username = this.$el.find('.username-step');
    username
      .find('.username-error')
      .text(reason)
      .show();
    username.addClass('is-invalid');
  },

  onValidUsername() {
    const username = this.$el.find('.username-step');
    username.find('.username-error').hide();
    username.removeClass('is-invalid');
  },

  onInvalidPassword(reason) {
    this.$el.find('#login_btn').removeClass('processing');
    const password = this.$el.find('.password-step');
    password
      .find('.password-error')
      .text(reason)
      .show();
    password.addClass('is-invalid');
  },

  onValidPassword() {
    const password = this.$el.find('.password-step');
    password.find('.password-error').hide();
    password.removeClass('is-invalid');
  },

  login(e) {
    e.preventDefault();
    this.$el.find('#login_btn').addClass('processing');
    const username = this.$el.find('.username-step');
    const password = this.$el.find('.password-step');
    username.removeClass('is-invalid');
    password.removeClass('is-invalid');
    username.find('.username-error').hide();
    password.find('.password-error').hide();
    this.$el.find('.login-error').hide();
    this.$el.find('.login-warning').hide();
    const saveLogin = this.$el.find('input[name="savelogin"]').is(':checked');
    this.model.set(
      {
        username: username.find('input[name=username]').val(),
        password: password.find('input[name=password]').val(),
        save_login: saveLogin,
      },
      { silent: true },
    );

    if (this.options.isLoginSignup) {
      const eventArr = { event: 'User Login Page' };
      const localObj = new LocalTracking();
      localObj.push(eventArr);
    }

    this.model.login();
  },

  onSuccess() {
    const msg = T_('Login successful!');
    this.$el
      .find('.login-error')
      .text('')
      .hide();
    this.$el
      .find('.login-warning')
      .text('')
      .hide();
    this.$el
      .find('.login-success')
      .text(msg)
      .show();
    this.vent.trigger('login:success');
  },

  onRedirection(toURL) {
    const msg = T_('Login successful! Redirecting...');
    this.$el
      .find('.login-success')
      .text(msg)
      .show();
    this.vent.trigger('login:redirection', { toURL });
  },

  onError(reason) {
    this.$el.find('#login_btn').removeClass('processing');
    if (reason === 'none') {
      this.$el.find('.login-error').hide();
    } else {
      this.$el
        .find('.login-error')
        .text(reason)
        .show();
    }
  },

  onSuspended(toURL) {
    this.vent.trigger('login:redirection', { toURL, suspended: true });
  },

  onWarning(reason) {
    this.$el.find('#login_btn').removeClass('processing');
    if (reason === 'none') {
      this.$el.find('.login-warning').hide();
    } else {
      this.$el
        .find('.login-warning')
        .text(reason)
        .show();
    }
  },

  trackPlayStoreClick() {
    _t.push([
      'user_action',
      {
        section: 'Login',
        subsection: 'DownloadPlayStore',
        label: 'LoginDownload',
        action: 'click',
      },
    ]);
  },

  trackAppStoreClick() {
    _t.push([
      'user_action',
      {
        section: 'Login',
        subsection: 'DownloadAppStore',
        label: 'LoginDownload',
        action: 'click',
      },
    ]);
  },

  showRecoverPassword(e) {
    e.preventDefault();
    const options = {
      loginModel: this.model,
      loginTitle: this.options.title,
      signupTitle: this.options.signupTitle,
      hideFacebook: this.options.hideFacebook,
      hideLookingFor: this.options.hideLookingFor,
      isLoginSignup: this.options.isLoginSignup,
      isFreemarket: this.options.isFreemarket,
      switchToAlternateSignup: this.options.switchToAlternateSignup,
    };
    this.vent.trigger('show:recoverpassword', options);
  },

  showFBLogin() {
    this.vent.trigger('show:fblogin', { loginModel: this.model });
  },

  switchToSignup(e) {
    e.preventDefault();
    const options = {
      loginModel: this.model,
      title: this.options.signupTitle,
      loginTitle: this.options.title,
      hideFacebook: this.options.hideFacebook,
      hideLookingFor: this.options.hideLookingFor,
      isLoginSignup: this.options.isLoginSignup,
      isFreemarket: this.options.isFreemarket,
      switchToAlternateSignup: this.options.switchToAlternateSignup,
    };
    this.vent.trigger('show:signup', options);
  },

  render() {
    if (!this.options.isFreemarket) {
      this.options.playStoreUrl = 'https://bnc.lt/Ed5l/nPQu9RdcWr';
      this.options.appStoreUrl = 'https://bnc.lt/Ed5l/nPQu9RdcWr';
    }
    this.$el.html(
      this.template({
        options: this.options,
        model: this.model.toJSON(),
        T_,
      }),
    );

    if (!this.options.isFreemarket) {
      this.$el.find('#fl-logo').html(_.template(logoTpl)({ cdn_url }));
      this.$el.find('#appStore').html(_.template(appStoreTpl));
      this.$el.find('#playStore').html(_.template(playStoreTpl));
    }
    return this;
  },

  close(event, clickedFacebookButton) {
    if (!this.options.isLoginSignup) {
      this.vent.trigger('close', clickedFacebookButton);
    }
  },

  clickFBLogin(event) {
    this.close(event, true);
  },

  /**
   * Destroy the view. Unbind all references to enable the view
   * to be garbage collected and remove the el from the DOM.
   */
  destroy() {
    this.model.unbind('username:valid', this.onValidUsername, this);
    this.model.unbind('username:invalid', this.onInvalidUsername, this);
    this.model.unbind('password:valid', this.onValidPassword, this);
    this.model.unbind('password:invalid', this.onInvalidPassword, this);
    this.model.unbind('success', this.onSuccess, this);
    this.model.unbind('error', this.onError, this);
    this.model.unbind('redirection', this.onRedirection, this);
    this.model.unbind('suspended', this.onSuspended, this);
    this.remove();
  },
});
